import type { Article, WithContext } from 'schema-dts';
import {
  type GetNewsArticleDetailsQuery,
  type StrapiArticle,
  StrapiArticleType,
} from '#variant/apollo/types/types';

export function useGoogleNews(
  url: string,
  newsQuery: GetNewsArticleDetailsQuery,
): WithContext<Article> | undefined {
  if (
    newsQuery === undefined ||
    newsQuery.articles === undefined ||
    newsQuery.articles.length !== 1
  ) {
    return undefined;
  }

  const article = newsQuery.articles[0] as StrapiArticle;

  return {
    '@context': 'https://schema.org',
    '@type':
      article.type === StrapiArticleType.Blog ? 'BlogPosting' : 'NewsArticle',
    headline: article.title,
    description: article.teaserText,
    image: article.thumbnailImage?.url,
    datePublished: article.publishedAt,
    dateModified: article.updatedAt,
    url,
  } as WithContext<Article>;
}
